<template>
    <div class="sales-category-list">
        <div class="title">
            <h3>销售分类</h3>
            <el-button type="primary" size="mini" @click="handleAdd">新增</el-button>
        </div>
        <el-table :data="data" style="width: 100%">
            <!-- 分类名称 -->
            <el-table-column prop="categoryName" label="分类名称" ></el-table-column>
            <!-- 排序 -->
            <el-table-column prop="showOrder" label="排序" >
                <template slot-scope="scope">
                    <!-- 图标按钮 上移 下移 置顶 置底 -->
                    <div class="sort-buttons">
                        <el-button size="mini" type="primary" @click="item.handler(scope.$index)" v-for="(item, index) in srotButtons" :key="index" :icon="item.icon" class="sort-button"></el-button>
                    </div>
                </template>
            </el-table-column>
            <!-- 创建事件 -->
            <el-table-column prop="createTime" label="创建时间" ></el-table-column>
            <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                    <el-button type="text"  @click="handleEdit(scope.$index)">编辑</el-button>
                    <el-button type="text" @click="handleDelete(scope.$index)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <SalesCategoryDialog ref="salesCategoryDialog" :title="dialogTitle" @confirm="handleConfirm"></SalesCategoryDialog>
    </div>
</template>

<script>
import SalesCategoryDialog from './components/SalesCategoryDialog.vue'
import { plSaleCategorys, plSaleCategoryAdd, plSaleCategoryDelete, plSaleCategorysExchange, plSaleCategorysTop, plSaleCategorysBottom, plSaleCategoryEdit } from "@/api/saleRule/agent"

export default {
    name: 'SalesCategoryList',
    components: {
        SalesCategoryDialog
    },
    data() {
        return {
            srotButtons: [
                {
                    type: 'top',
                    text: '置顶',
                    icon: 'el-icon-sort-up',
                    handler: this.handleTop
                },
                {
                    type: 'up',
                    text: '上移',
                    icon: 'el-icon-arrow-up',
                    handler: this.handleUp
                },
                {
                    type: 'down',
                    text: '下移',
                    icon: 'el-icon-arrow-down',
                    handler: this.handleDown
                },
                {
                    type: 'bottom',
                    text: '置底',
                    icon: 'el-icon-sort-down',
                    handler: this.handleBottom
                }
            ],
            // 列表数据
            data: [],
            dialogTitle: '新增销售分类'
        }
    },
    created() {
        this.getSaleCategorys()
    },
    methods: {
        // 获取销售分类列表
        async getSaleCategorys() {
            const res = await plSaleCategorys()
            if (res) {
                this.data = res
            }

        },
        // 排序置顶
        handleTop(index) {
            const row = this.data[index]
            plSaleCategorysTop(row.id).then(res => {
                if (res) {
                    this.getSaleCategorys()    
                }
            })
        },
        // 排序置底
        handleBottom(index) {
            const row = this.data[index]
            plSaleCategorysBottom(row.id).then(res => {
                if (res) {
                    this.getSaleCategorys()    
                }
            })
        },
        handleUp(index) {
            this.handleExchange(index, index - 1)
        },
        handleDown(index) {
            this.handleExchange(index, index + 1)
        },
        // 编辑按钮的方法
        handleEdit(index) {
            const row = this.data[index]
            const obj =  {
                categoryName: row.categoryName || '',
                id: row.id,
            }
            this.dialogTitle = '编辑销售分类'
            this.$refs.salesCategoryDialog.handleEdit(obj)
        },
        // 删除按钮的方法
        handleDelete(index) {
            const row = this.data[index]
            this.$confirm('确认删除该分类吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                plSaleCategoryDelete(row.id).then(res => {
                    if (res) {
                        this.getSaleCategorys()
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        // 新增按钮的方法
        handleAdd() {
            this.dialogTitle = '新增销售分类'
            this.$refs.salesCategoryDialog.handleDialogVisible()
        },
        // 确认新增按钮的方法
        handleConfirm(obj) {
            if (obj.categoryName) {
                if (obj.id) {
                    this.handleEditConfirm(obj)
                }else{  
                    plSaleCategoryAdd(obj).then(res => {
                        if (res) {
                            this.getSaleCategorys()
                        }
                    })
                }
            }
        },
        // 确认编辑按钮的方法
        handleEditConfirm(obj) {
            if (obj.categoryName) {
                plSaleCategoryEdit(obj).then(res => {
                    if (res) {
                        this.getSaleCategorys()
                    }
                })
            }
        },
        // 交换位置方法
        handleExchange(index1, index2) {
            const row1 = this.data[index1]
            const row2 = this.data[index2]
            if (!row1 || !row2){
                return
            }
            plSaleCategorysExchange({frontClassId: row1.id, afterClassId: row2.id }).then(res => {
                if (res) {
                    this.getSaleCategorys()
                }
            })
        }
    },
    
}
</script>
<style scoped lang="scss">
.sales-category-list{
    padding: 20px;
    background-color: #fff;
    height: 100%;
    .title{
        display: flex;
        justify-content: space-between;
        align-items: center;
        h3{
            margin: 0px;
        }
    }
    .sort-buttons{
        .sort-button{
            margin: 0px;
            border-radius: 0px;
        }
        .el-button:first-child{
            border-top-left-radius: 4px;
            border-bottom-left-radius: 4px;
        }
        .el-button:last-child{
            border-top-right-radius: 4px;
            border-bottom-right-radius: 4px;
        }
    }
}
</style>